import { cn } from "~/lib/cn";

interface FormStatusProps {
  /** `status` for progress and confirmations (polite); `alert` for a failed send or a rate limit. */
  tone: "status" | "alert";
  children?: React.ReactNode;
  id?: string;
  className?: string;
  /** `public` (T872 S3) — the delivery's `.request-status` line under a public field set. */
  variant?: "default" | "public";
}

/**
 * T872 S2 — the one line under a public form that says what the send is doing
 * (`.request-status` in the delivery): «Preparando tu guía…», «Reenviada. …», or the
 * error that keeps her draft. Mounted empty and filled when there is something to say,
 * so the live region exists before the announcement. Empty content renders nothing
 * visible but keeps the node.
 */
export function FormStatus({ tone, children, id, className, variant = "default" }: FormStatusProps) {
  return (
    <p
      id={id}
      role={tone}
      aria-live={tone === "alert" ? "assertive" : "polite"}
      className={cn(variant === "public" ? "pub-field-status" : "af-helper", tone === "alert" && "is-error", className)}
      hidden={children == null || children === false || children === ""}
    >
      {children}
    </p>
  );
}
